import React from "react";
import HeroSection from "../components/HeroSection";
import icons from "../constants/icons.ts";
import { heroSections } from "../constants/data.ts";

const Disclaimer = () => {
  return (
    <main className="bg-background">
      <HeroSection {...heroSections.disclaimer} />

      {/* Effective date */}
      <section className="py-16 md:py-24 px-outer">
        <div className="container mx-auto max-w-3xl">
          <h2 className="heading-main text-center mb-12">
            Effective Date: 27/01/2022
          </h2>

          <div className="space-y-6">
            <div className="flex gap-4">
              <i className={`${icons.actions.checkCircle} text-2xl text-primary flex-shrink-0 mt-1`}></i>
              <div>
                <h3 className="heading mb-2">Use of Information</h3>
                <p className="text-body">
                  The information provided on the Westlisoft Technologies Pvt Ltd website (www.westlisoft.com) is for general informational purposes only. While we strive to keep the information up to date and accurate, we make no representations or warranties of any kind, express or implied, about the completeness, accuracy, reliability, suitability, or availability of the information contained on the Website. Any reliance you place on such information is strictly at your own risk.
                </p>
              </div>
            </div>

            <div className="flex gap-4">
              <i className={`${icons.actions.checkCircle} text-2xl text-primary flex-shrink-0 mt-1`}></i>
              <div>
                <h3 className="heading mb-2">Professional Advice</h3>
                <p className="text-body">
                  The information provided on this Website is not intended as legal, financial, or professional advice. You should seek professional advice before making any decisions or taking any action based on the information on this Website.
                </p>
              </div>
            </div>

            <div className="flex gap-4">
              <i className={`${icons.actions.checkCircle} text-2xl text-primary flex-shrink-0 mt-1`}></i>
              <div>
                <h3 className="heading mb-2">No Guarantees</h3>
                <p className="text-body">
                  We do not guarantee that the information provided on the Website is accurate, complete, or up to date. We may make changes to the content at any time without notice, but we have no obligation to update the information on the Website.
                </p>
              </div>
            </div>

            <div className="flex gap-4">
              <i className={`${icons.actions.checkCircle} text-2xl text-primary flex-shrink-0 mt-1`}></i>
              <div>
                <h3 className="heading mb-2">Third-Party Links</h3>
                <p className="text-body">
                  We do not guarantee that the information provided on the Website is accurate, complete, or up to date. We may make changes to the content at any time without notice, but we have no obligation to update the information on the Website.
                </p>
              </div>
            </div>

            <div className="flex gap-4">
              <i className={`${icons.actions.checkCircle} text-2xl text-primary flex-shrink-0 mt-1`}></i>
              <div>
                <h3 className="heading mb-2">Limitation of Liability</h3>
                <p className="text-body">
                  Westlisoft Technologies Pvt Ltd and its affiliates, officers, directors, employees, or agents shall not be liable for any direct, indirect, incidental, consequential, or exemplary damages resulting from your use of this Website or the information it contains.
                </p>
              </div>
            </div>

            <div className="flex gap-4">
              <i className={`${icons.actions.checkCircle} text-2xl text-primary flex-shrink-0 mt-1`}></i>
              <div>
                <h3 className="heading mb-2">No Warranty</h3>
                <p className="text-body">
                  We make no warranties, representations, or guarantees of any kind, whether expressed or implied, regarding the operation of this Website or the information, content, materials, or products included on the Website.
                </p>
              </div>
            </div>

            <div className="flex gap-4">
              <i className={`${icons.actions.checkCircle} text-2xl text-primary flex-shrink-0 mt-1`}></i>
              <div>
                <h3 className="heading mb-2">Governing Law</h3>
                <p className="text-body">
                  This Website is controlled by Westlisoft Technologies Pvt Ltd from our offices within Hyderabad. It can be accessed from all countries around the world. By accessing the Website, you agree that the laws of The Telangana State will apply to these terms and conditions, and that any dispute of any sort that might arise between you and us will be subject to the exclusive jurisdiction of the courts in Telangana.
                </p>
              </div>
            </div>

            <div className="flex gap-4">
              <i className={`${icons.actions.checkCircle} text-2xl text-primary flex-shrink-0 mt-1`}></i>
              <div>
                <h3 className="heading mb-2">Contact Us</h3>
                <p className="text-body">
                  If you have any questions or concerns about this Website Disclaimer, please contact us at info@westlisoft.com.
                </p>
              </div>
            </div>

          </div>
        </div>
      </section>
    </main>
  );
};

export default Disclaimer;
